module.exports = __webpack_public_path__ + "static/media/instagram.27d7195c.webp";